module.exports = "/images/empty_house.jpg?17b296ed28a1bbad4c7639ba959c542f";